import styles from './SettingsDialog.module.css'
import { LinkButton } from './LinkButton'
import { ClickAwayListener, Popper } from '@mui/material'
import { ProfileIcon } from 'shared/icons/ProfileIcon'
import { NotificationIcon } from 'shared/icons/NotificationIcon'
import { HowToInstallIcon } from 'shared/icons/HowToInstallIcon'
import { AboutIcon } from 'shared/icons/AboutIcon'
import { LogoutIcon } from 'shared/icons/LogoutIcon'
import { ApplicationPaths } from 'components/api-authorization/ApiAuthorizationConstants'
import { ShareButton } from './ShareButton'
import { Button } from './Button'
import { useAppDispatch, useAppSelector } from 'shared/hooks/store'
import { selectNotificationsSettingsDialogOpen, setNotificationsSettingsDialogOpen } from 'store/applicationSlice'


interface SettingsDialogProps {
    open: boolean
    anchorElement?: HTMLElement | null
    onClose: (event: any) => void
}

export const SettingsDialog = (props: SettingsDialogProps): JSX.Element => {
    const {
        open,
        anchorElement,
        onClose
    } = props

    const dispatch = useAppDispatch()
    const notificationsSettingsDialogOpen = useAppSelector(selectNotificationsSettingsDialogOpen)

    const popperOptions: any = {
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 30],
                },
            },
            {
                name: 'flip',
                enabled: false,
            }
        ]
    }

    const handleClickAway = (event: any) => {
        onClose?.(event)
    }


    const handleNotificationButtonClick = (event: any) => {
        dispatch(setNotificationsSettingsDialogOpen(!notificationsSettingsDialogOpen))
    }

    return (
            <Popper
                className={styles.SettingsDialog__Popper}
                open={open}
                anchorEl={anchorElement}
                popperOptions={popperOptions}
                placement={`bottom-end`}
        >
            <ClickAwayListener onClickAway={handleClickAway}>
                <div className={styles.Popper__Content}>
                    <ul className={styles.Popper__List}>
                        <li>
                            <LinkButton
                                caption={'Profile'}
                                href={`${ApplicationPaths.Profile}`}
                                icon={<ProfileIcon className={styles.LinkButton__Icon} />}
                            />
                        </li>
                        <li>
                            <Button
                                caption={'Notification'}
                                onClick={handleNotificationButtonClick}
                                icon={<NotificationIcon className={styles.Button__Icon} />}
                            />
                        </li>
                        <li>
                            <LinkButton
                                caption={'How to install'}
                                href={'/install/instruction'}
                                icon={<HowToInstallIcon className={styles.LinkButton__Icon} />}
                            />
                        </li>
                        <li>
                            <LinkButton
                                caption={'About'}
                                href={'/about'}
                                icon={<AboutIcon className={styles.LinkButton__Icon} />}
                            />
                        </li>
                        <li>
                            <LinkButton
                                caption={'Logout'}
                                href={`${ApplicationPaths.LogOut}`}
                                icon={<LogoutIcon className={styles.LinkButton__Icon} />}
                            />
                        </li>
                        <li>
                            <ShareButton />
                        </li>
                    </ul>
                </div>
            </ClickAwayListener>
                </Popper>

    )
}